import {
	connect
} from 'react-redux'
import SimpleDataTable from '../components/common/SimpleDataTable.jsx';
import {
	findOrderDetailList
} from '../actions';

const mapStateToProps = (state) => ({
	data: state.getIn(['orderDetailListReducer', 'orderDetailList']),
	fields: {
		order_detail_id: '編號',
		customer_gear_name: '產品名稱',
		quantity: '訂貨數量',
		model_name: '規格',
		spec_id: '料號'
	},
	keys: ['order_id', 'order_detail_id', 'gear_name']
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: () => {
		if (ownProps.orderId) {
			dispatch(findOrderDetailList({ orderId: ownProps.orderId }));
		}
	}
})

const OrderDetailListViewContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(SimpleDataTable)

export default OrderDetailListViewContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderDetailListViewContainer.jsx